import { Config } from "@amtana/module";
import { z } from "zod";

// Where a mailed unsubscribe link points: the platform's own origin, the
// same value auth's `PLATFORM_ORIGIN` already answers (an environment
// variable has exactly one owner, so this declares its own, prefixed by this
// module, the same way organization's invite link does; D073). The secret
// signs that link's token (D074): random per deployment in development,
// refused once NODE_ENV is "production" while it still holds that default,
// the same guard auth's session secret uses. Snoozes, quiet hours, bursts and
// digests release as wakes of a process manager, not a scheduled sweep
// (D077 revision 4, S26.16), so this config carries no sweep interval.

export const DEV_UNSUBSCRIBE_SECRET = "n".repeat(32);

export const notificationConfig = Config.define((c) => ({
  platformOrigin: c.env("NOTIFICATION_PLATFORM_ORIGIN", z.url().default("http://127.0.0.1:4312")),
  unsubscribeSecret: c.env(
    "NOTIFICATION_UNSUBSCRIBE_SECRET",
    z
      .string()
      .min(
        32,
        "needs 32 characters or more: an unsubscribe link's signature is only as strong as this secret.",
      )
      .default(DEV_UNSUBSCRIBE_SECRET),
    {
      refuseInProduction: (value) =>
        value === DEV_UNSUBSCRIBE_SECRET
          ? "still the development default; an unsubscribe link's signature is only as strong as this secret"
          : undefined,
    },
  ),
}));
